<template>
  <v-sheet
    class="px-3 mx-auto"
    color="transparent"
    max-width="960px"
    width="100%"
  >
    <v-overlay :value="isLoadingInsert">
      <v-progress-circular indeterminate size="64" color="primary" />
    </v-overlay>

    <template v-if="isLoading">
      <v-card class="mt-6 mt-sm-7 form-card">
        <div class="d-flex align-center">
          <v-progress-circular indeterminate size="20" color="red" />

          <div class="text-h6 font-weight-medium ml-3">Carregando...</div>
        </div>
      </v-card>
    </template>

    <template v-else>
      <v-sheet class="fixed-top" color="#f7f8fa">
        <div class="d-flex align-center justify-space-between px-3">
          <TitleFormWidget
            class="py-4"
            :icon="itemId ? 'clipboard-text-outline' : 'clipboard-outline'"
            :title="title"
          />

          <div class="d-flex align-center">
            <div class="grey--text text-body-1 mr-2">Status:</div>
            <SelectFarmField v-model="item.status" :items="status" />
          </div>
        </div>

        <v-divider />
      </v-sheet>

      <v-form @submit.prevent="submit" ref="form">
        <v-card class="form-card">
          <div class="position-relative">
            <TitleFormWidget icon="account-outline" title="Cliente" small />

            <v-btn
              @click="toggleDialogPeople('contact')"
              class="btn-new-people"
              color="primary"
              outlined
              dense
            >
              <v-icon color="primary" size="14">mdi-plus</v-icon>

              <div class="text-none ml-2">Novo Cliente</div>
            </v-btn>
          </div>

          <div class="mt-3 mx-n3">
            <template>
              <PeopleSelect
                @change="(v) => (item.client_id = v)"
                @delete="item.client_id = null"
                :items="peoples"
                :selected="item.client_id"
              />
            </template>
          </div>
        </v-card>

        <v-card class="mt-6 mt-sm-8 form-card">
          <TitleFormWidget
            icon="text-box-multiple-outline"
            title="Informações Gerais"
            small
          />

          <div class="mt-3 grid-list grid-list-5-columns">
            <SelectFarmField
              v-model="item.metric_system"
              title="Unidade de área"
              :items="areaUnit"
              clearable
            />

            <div class="grid-list grid-list-2-columns span2">
              <TextFarmField
                v-model="item.total_area_min"
                title="Área total"
                placeholder="Min"
                :suffix="formatAreaUnit(item.metric_system)"
                area
              />

              <TextFarmField
                v-model="item.total_area_max"
                title="&nbsp;"
                placeholder="Max"
                :suffix="formatAreaUnit(item.metric_system)"
                area
              />
            </div>

            <div class="grid-list grid-list-2-columns span2">
              <TextFarmField
                v-model="item.open_area_min"
                title="Área aberta"
                placeholder="Min"
                :suffix="formatAreaUnit(item.metric_system)"
                area
              />

              <TextFarmField
                v-model="item.open_area_max"
                title="&nbsp;"
                placeholder="Max"
                :suffix="formatAreaUnit(item.metric_system)"
                area
              />
            </div>

            <SelectFarmField
              v-model="item.business"
              :items="areaType"
              title="Negociação"
              clearable
            />

            <SelectFarmField
              v-model="item.purpose"
              :items="purpose"
              title="Finalidade"
              clearable
            />

            <div class="grid-list grid-list-2-columns span2">
              <TextFarmField
                v-model="item.price_min"
                title="Valor"
                placeholder="Min"
                monetary
              />

              <TextFarmField
                v-model="item.price_max"
                title="&nbsp;"
                placeholder="Max"
                monetary
              />
            </div>
          </div>
        </v-card>

        <v-card class="mt-6 mt-sm-8 form-card">
          <TitleFormWidget
            icon="text-box-multiple-outline"
            title="Descrição"
            small
          />

          <TextareaFarmField v-model="item.text" class="mt-3" />
        </v-card>

        <v-sheet class="mt-6 mt-sm-8 fixed-bottom" color="#f7f8fa">
          <v-divider />

          <div class="d-flex justify-end py-4 px-6">
            <v-btn
              @click="dialogToGoBack = !dialogToGoBack"
              class="rounded-lg"
              color="#dddddd"
              outlined
            >
              <v-icon color="black" size="20">mdi-undo-variant</v-icon>
              <div
                class="black--text text-body-1 text-none font-weight-medium ml-2"
              >
                Voltar
              </div>
            </v-btn>

            <v-btn
              class="rounded-lg ml-2"
              color="orange"
              type="submit"
              depressed
            >
              <v-icon color="white" size="20">mdi-content-save</v-icon>
              <div
                class="white--text text-body-1 text-none font-weight-medium ml-2"
              >
                {{ itemId ? "Atualizar" : "Salvar" }}
              </div>
            </v-btn>
          </div>
        </v-sheet>
      </v-form>
    </template>

    <v-dialog
      v-if="dialogPeople"
      v-model="dialogPeople"
      max-width="600"
      persistent
    >
      <PeopleStoreDialog
        @close="toggleDialogPeople"
        @success="loadPeoples"
        :type="peopleType"
      />
    </v-dialog>

    <v-dialog
      v-if="dialogToGoBack"
      v-model="dialogToGoBack"
      max-width="500"
      persistent
    >
      <ToGoBackDialog @close="dialogToGoBack = !dialogToGoBack" />
    </v-dialog>
  </v-sheet>
</template>

<script>
import TitleFormWidget from "@/components/widgets/TitleForm.vue";
import PeopleSelect from "@/pages/orders/store/People.vue";
import TextFarmField from "@/components/fields/farm/Text.vue";
import SelectFarmField from "@/components/fields/farm/Select.vue";
import TextareaFarmField from "@/components/fields/farm/Textarea.vue";
import PeopleStoreDialog from "@/components/dialogs/PeopleStore.vue";
import ToGoBackDialog from "@/components/dialogs/ToGoBack.vue";
import variables from "@/utils/variables";
import formatAreaUnit from "@/utils/formatAreaUnit";
import moneyToDecimal from "@/utils/moneyToDecimal";
import { mapActions } from "vuex";

export default {
  components: {
    TitleFormWidget,
    PeopleSelect,
    TextFarmField,
    SelectFarmField,
    TextareaFarmField,
    PeopleStoreDialog,
    ToGoBackDialog,
  },
  data: () => ({
    isLoading: false,
    dialogPeople: false,
    item: {
      id: null,
      client_id: null,
      metric_system: null,
      total_area_min: null,
      total_area_max: null,
      open_area_min: null,
      open_area_max: null,
      status: 1,
      purpose: null,
      business: null,
      price_min: null,
      price_max: null,
      text: null,
    },
    peoples: [],
    isLoadingInsert: false,
    dialogToGoBack: false,
    status: variables.orderStatus,
    purpose: variables.purpose,
    areaType: variables.orderAreaType,
    areaUnit: variables.areaUnit,
  }),
  computed: {
    itemId() {
      return this.$route.params.id || null;
    },
    title() {
      return !this.itemId ? "Novo Pedido" : "Alterar Pedido";
    },
    xsOnly() {
      return this.$vuetify.breakpoint.xsOnly;
    },
  },
  methods: {
    ...mapActions("orders", ["getOrder", "insertOrder", "updateOrder"]),
    ...mapActions("peoples", ["listPeoples"]),
    async submit() {
      this.isLoadingInsert = true;

      const form = new FormData();

      if (
        !!this.item.total_area_min &&
        !!this.item.total_area_max &&
        this.moneyToDecimal(this.item.total_area_min) >
          this.moneyToDecimal(this.item.total_area_max)
      ) {
        this.$eventHub.$emit("snackBar", {
          icon: "mdi-alert-circle",
          message: `Área total mínima maior que a máxima. Altere e tente novamente.`,
          type: "error",
          timeout: 5000,
        });

        return;
      }

      if (
        this.item.open_area_min &&
        this.item.open_area_max &&
        this.moneyToDecimal(this.item.open_area_min) >
          this.moneyToDecimal(this.item.open_area_max)
      ) {
        this.$eventHub.$emit("snackBar", {
          icon: "mdi-alert-circle",
          message: `Área aberta mínima maior a máxima. Altere e tente novamente.`,
          type: "error",
          timeout: 5000,
        });

        return;
      }

      if (
        this.item.price_min &&
        this.item.price_max &&
        this.moneyToDecimal(this.item.price_min) >
          this.moneyToDecimal(this.item.price_max)
      ) {
        this.$eventHub.$emit("snackBar", {
          icon: "mdi-alert-circle",
          message: `Valor mínimo maior que o máximo. Altere e tente novamente.`,
          type: "error",
          timeout: 5000,
        });

        return;
      }

      for (let property in this.item) {
        if (this.item[property] || this.item[property] == 0) {
          if (!["client"].includes(property))
            form.append(property, this.item[property]);
        }
      }

      const action = this.itemId ? this.updateOrder : this.insertOrder;
      const r = await action.call(this, form);

      if (r) {
        this.$eventHub.$emit("snackBar", {
          icon: "mdi-account-plus",
          message: `${
            this.itemId ? "Atualização realizada" : "Cadastro realizado"
          } com sucesso.`,
          type: "success",
        });

        this.$router.push({ path: "/pedidos" });
      } else {
        this.$eventHub.$emit("snackBar", {
          icon: "mdi-alert-circle",
          message: `Erro ao ${
            this.itemId ? "atualizar" : "cadastrar"
          }. Tente novamente.`,
          type: "error",
        });
      }

      this.isLoadingInsert = false;
    },
    async loadPeoples() {
      this.peoples = await this.listPeoples({ all: 1 });
      this.toggleDialogPeople();
    },
    async onLoad() {
      this.isLoading = true;
      this.peoples = await this.listPeoples({ all: 1 });

      if (!this.itemId) {
        this.isLoading = false;
        return;
      }

      this.item = await this.getOrder(this.itemId);
      if (!this.item.status) this.item.status = 1;
      this.isLoading = false;
    },
    toggleDialogPeople(type = null) {
      this.peopleType = type || "contact";

      this.dialogPeople = !this.dialogPeople;
    },
    formatAreaUnit,
    moneyToDecimal,
  },
  created() {
    this.onLoad();
  },
};
</script>

<style lang="scss" scoped>
$gap: 12px;

.form-card {
  border: 1px solid #e5e5e5 !important;
  border-radius: 14px !important;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px -1px rgba(0, 0, 0, 0.1) !important;
  padding: 24px;
}

.grid-list {
  display: grid;
  gap: $gap;
}

.grid-list-2-columns {
  $columns: 2;

  display: grid;
  gap: $gap;
  grid-template-columns: repeat(
    $columns,
    calc((100% / $columns) - ($gap * ($columns - 1) / $columns))
  );
}

.grid-list-4-columns {
  $columns: 4;

  display: grid;
  gap: $gap;
  grid-template-columns: repeat(
    $columns,
    calc((100% / $columns) - ($gap * ($columns - 1) / $columns))
  );
}

.grid-list-5-columns {
  $columns: 5;

  display: grid;
  gap: $gap;
  grid-template-columns: repeat(
    $columns,
    calc((100% / $columns) - ($gap * ($columns - 1) / $columns))
  );
}

.span2 {
  grid-column: span 2;
}

.span3 {
  grid-column: span 3;
}

.span4 {
  grid-column: span 4;
}

.fixed-top {
  top: 64px;
  margin-bottom: -1px;
  margin-left: -12px;
  margin-right: -12px;
  position: sticky;
  z-index: 2;

  @media screen and (max-width: 959.9px) {
    top: 56px;
  }
}

.fixed-bottom {
  bottom: 0;
  margin-left: -12px;
  margin-right: -12px;
  position: sticky;
}

.btn-new-people {
  border: 1px dashed rgba(16, 120, 35, 0.3) !important;
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
}
</style>
